<template>
  <div>
    <!-- WEB VIEW -->
    <div v-if="checkboxesPosition === 'right-side' || productType" class="filter-header-web right-side">
      <div class="title">Filter by:</div>

      <div v-if="!productType">
        <EcommerceFilterProductType></EcommerceFilterProductType>
      </div>

      <div class="categories">
        <EcommerceFilterCategories :categorySelection="categorySelection"></EcommerceFilterCategories>
      </div>
    </div>
    <div v-if="checkboxesPosition === 'below' && !productType" class="filter-header-web below">
      <div class="product-type">
        <div>Filter by:</div>

        <div>
          <EcommerceFilterProductType></EcommerceFilterProductType>
        </div>
      </div>

      <div class="categories">
        <EcommerceFilterCategories></EcommerceFilterCategories>
      </div>
    </div>

    <!-- MOBILE VIEW -->
    <div class="filter-header-mobile">
      <div class="title">
        <button type="button" @click="showMobileFilter = !showMobileFilter">
          <span>Filter</span>
          <span v-if="showMobileFilter"><i class="fas fa-chevron-down"></i></span>
          <span v-if="!showMobileFilter"><i class="fas fa-chevron-up"></i></span>
        </button>
      </div>
      <div v-if="showMobileFilter">
        <EcommerceFilterProductType v-if="!productType"></EcommerceFilterProductType>
        <EcommerceFilterCategories :categorySelection="categorySelection"></EcommerceFilterCategories>
      </div>
    </div>
  </div>
</template>
<script>
import EcommerceFilterProductType from './ProductType.vue';
import EcommerceFilterCategories from './Categories.vue';

export default {
  name: 'EcommerceFilterHeader',
  props: {
    checkboxesPosition: {
      // This prop doesn't work with productType != null and categorySelection = 'single'
      type: String,
      default: 'right-side',
      validator: (value) => ['right-side', 'below'].includes(value),
    },
    categorySelection: {
      type: String,
      default: 'multiple',
      validator: (value) => ['multiple', 'single'].includes(value),
    },
    productType: {
      type: String,
      validator: (value) => ['adoption', 'wildcard'].includes(value) || !value,
    },
  },
  data() {
    return {
      showMobileFilter: false,
    };
  },
  components: {
    EcommerceFilterProductType,
    EcommerceFilterCategories,
  },
};
</script>

<style scoped>
.filter-header {
  width: 100%;
}

.filter-header-web {
  background-color: #ededed;
  border: 1px solid #d1d1d1;
  box-sizing: border-box;
  border-radius: 2px;
}

.filter-header-web.right-side {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  padding: 20px 0;
}

.filter-header-web.below {
  display: flex;
  flex-direction: column;
  padding: 20px;
}

.filter-header-mobile {
  display: none;
}

.product-type {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
  padding: 0 50px;
}

.title {
  text-decoration: underline;
  padding: 0 50px;
}

.categories {
  flex: 1;
  padding: 0 50px 0 70px;
}

@media only screen and (max-width: 64em) {
  .title {
    padding: 0 20px;
  }

  .categories {
    padding: 0 20px;
  }
}

@media only screen and (max-width: 40em) {
  .filter-header-web {
    display: none;
  }

  .filter-header-web.below {
    display: none;
  }

  .filter-header-web.right-side {
    display: none;
  }

  .filter-header-mobile {
    display: flex;
    flex-direction: column;
  }

  .title {
    width: 100%;
    text-decoration: none;
    padding: 0;
    margin-bottom: 5px;
  }

  button {
    cursor: pointer;
    background-color: #ededed;
    border: 1px solid #d1d1d1;
    box-sizing: border-box;
    border-radius: 0;
    height: 60px;
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 30px;
  }
}
</style>



// WEBPACK FOOTER //
// Header.vue?57f91b79